import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoCompleteComponent } from './autocomplete.component';
import { AutoCompleteModule } from './autocomplete.module';
/**
 * NgModule definition for the AutoComplete component with providers.
 */
export class AutoCompleteAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, AutoCompleteModule],
    exports: [
        AutoCompleteModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AutoCompleteAllModule_tsickle_Closure_declarations() {
/** @type {?} */
AutoCompleteAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AutoCompleteAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
